var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visual-test-example"},[_c('div',{staticClass:"example-title"},[_c('p',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"example-content",style:({ width: _vm.width, height: _vm.height }),attrs:{"id":_vm.id}},[_c(_vm.loadedComponent,_vm._b({tag:"component"},'component',_vm.$attrs,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }